import ProctorPage from './ProctorPage';

export default ProctorPage;
